export default "__VITE_ASSET__77c8e2c0__"